(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ey-collection-about"] && !Shopify.designMode) return;
  try {
    
class EyCollectionAbout {
  constructor(root) {
    this.root = root;
    this.body = root.querySelector('[data-ey-colabout-body]');
    this.toggle = root.querySelector('[data-ey-colabout-toggle]');
    this.label = root.querySelector('[data-ey-colabout-label]');
    if (!this.body || !this.toggle) return;

    this.moreLabel = this.toggle.dataset.more || this.label.textContent.trim();
    this.lessLabel = this.toggle.dataset.less || 'Show less';

    // Only offer the toggle when the text is actually taller than the clamp.
    if (this.body.scrollHeight - this.body.clientHeight > 8) {
      this.toggle.hidden = false;
    } else {
      this.body.classList.remove('is-clamped');
    }

    this.toggle.addEventListener('click', () => this.onClick());
  }

  onClick() {
    const open = this.body.classList.toggle('is-clamped') === false;
    this.toggle.setAttribute('aria-expanded', String(open));
    this.label.textContent = open ? this.lessLabel : this.moreLabel;
    if (!open) {
      this.root.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  }
}

document.querySelectorAll('.ey-colabout').forEach((el) => new EyCollectionAbout(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ey-header"] && !Shopify.designMode) return;
  try {
    
class EyHeader {
  constructor(root) {
    this.root = root;
    this.drawer = document.querySelector('[data-ey-drawer]');
    this.openBtn = root.querySelector('[data-ey-drawer-open]');
    this.onScroll = this.onScroll.bind(this);
    this.bind();
    this.onScroll();
  }
  bind() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
    if (this.openBtn) this.openBtn.addEventListener('click', () => this.open());
    if (this.drawer) {
      this.drawer.querySelectorAll('[data-ey-drawer-close]').forEach((el) =>
        el.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });
    }
  }
  onScroll() { this.root.classList.toggle('is-scrolled', window.scrollY > 6); }
  open() {
    if (!this.drawer) return;
    this.drawer.hidden = false;
    requestAnimationFrame(() => this.drawer.classList.add('is-open'));
    if (this.openBtn) this.openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const first = this.drawer.querySelector('.ey-drawer__close');
    if (first) first.focus();
  }
  close() {
    if (!this.drawer || this.drawer.hidden) return;
    this.drawer.classList.remove('is-open');
    if (this.openBtn) { this.openBtn.setAttribute('aria-expanded', 'false'); this.openBtn.focus(); }
    document.body.style.overflow = '';
    setTimeout(() => { this.drawer.hidden = true; }, 320);
  }
}
class EyDrawerSearch {
  constructor(form) {
    this.form = form;
    this.input = form.querySelector('[data-ey-search-input]');
    this.results = form.querySelector('[data-ey-search-results]');
    this.clearBtn = form.querySelector('[data-ey-search-clear]');
    this.status = form.querySelector('[data-ey-search-status]');
    this.timer = null;
    this.controller = null;
    this.index = -1;

    this.input.addEventListener('input', () => this.onInput());
    this.input.addEventListener('keydown', (e) => this.onKeydown(e));
    this.clearBtn.addEventListener('click', () => this.clear(true));
    // A submit with no term would land the shopper on an empty results page.
    this.form.addEventListener('submit', (e) => {
      if (!this.input.value.trim()) e.preventDefault();
    });
  }

  onInput() {
    const term = this.input.value.trim();
    this.clearBtn.hidden = term.length === 0;
    clearTimeout(this.timer);
    if (term.length < 2) { this.close(); return; }
    this.timer = setTimeout(() => this.search(term), 250);
  }

  async search(term) {
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    const url = '/search/suggest.json?q=' + encodeURIComponent(term)
      + '&resources[type]=product&resources[limit]=6'
      + '&resources[options][unavailable_products]=last';
    try {
      const res = await fetch(url, { signal: this.controller.signal });
      if (!res.ok) throw new Error(res.status);
      const data = await res.json();
      this.render(data.resources.results.products || [], term);
    } catch (e) {
      if (e.name !== 'AbortError') this.close();
    }
  }

  render(products, term) {
    this.index = -1;
    const esc = (s) => String(s).replace(/[&<>"']/g, (c) => (
      { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
    ));
    const money = (v) => '$' + Number(v).toFixed(2);
    // CDN urls from suggest.json may or may not already carry a query string.
    const sized = (u, w) => u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;

    if (!products.length) {
      this.results.innerHTML = '<p class="ey-drawersearch__empty">No matches for &ldquo;' + esc(term) + '&rdquo;. Try a brand or an age.</p>';
      this.open(0, term);
      return;
    }

    const rows = products.map((p) => {
      const img = p.featured_image && p.featured_image.url
        ? '<img class="ey-drawersearch__thumb" src="' + esc(sized(p.featured_image.url, 92)) + '" alt="" loading="lazy" width="46" height="46">'
        : '<span class="ey-drawersearch__thumb" aria-hidden="true"></span>';
      const price = p.available
        ? money(p.price)
        : '<span class="sold">Sold out</span>';
      return '<a class="ey-drawersearch__item" role="option" aria-selected="false" href="' + esc(p.url) + '">'
        + img
        + '<span class="ey-drawersearch__meta">'
        + '<span class="ey-drawersearch__name">' + esc(p.title) + '</span>'
        + '<span class="ey-drawersearch__price">' + price + '</span>'
        + '</span></a>';
    }).join('');

    this.results.innerHTML = rows
      + '<a class="ey-drawersearch__all" href="/search?q=' + encodeURIComponent(term) + '">'
      + 'See all results'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
      + '</a>';
    this.open(products.length, term);
  }

  open(count, term) {
    this.results.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    this.status.textContent = count
      ? count + ' result' + (count === 1 ? '' : 's') + ' for ' + term
      : 'No results for ' + term;
  }

  close() {
    this.results.hidden = true;
    this.results.innerHTML = '';
    this.input.setAttribute('aria-expanded', 'false');
    this.status.textContent = '';
    this.index = -1;
  }

  clear(focus) {
    this.input.value = '';
    this.clearBtn.hidden = true;
    this.close();
    if (focus) this.input.focus();
  }

  items() {
    return Array.from(this.results.querySelectorAll('.ey-drawersearch__item'));
  }

  onKeydown(e) {
    if (e.key === 'Escape') {
      if (this.results.hidden) return;
      e.stopPropagation(); // keep Escape from also closing the drawer
      this.clear(true);
      return;
    }
    const items = this.items();
    if (!items.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const step = e.key === 'ArrowDown' ? 1 : -1;
      this.index = (this.index + step + items.length) % items.length;
      items.forEach((el, i) => el.setAttribute('aria-selected', String(i === this.index)));
      items[this.index].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && this.index > -1) {
      e.preventDefault();
      items[this.index].click();
    }
  }
}

function eyHeaderInit() {
  document.querySelectorAll('[data-ey-header]').forEach((h) => {
    if (h.dataset.eyReady) return; h.dataset.eyReady = '1'; new EyHeader(h);
  });
  document.querySelectorAll('[data-ey-search]').forEach((f) => {
    if (f.dataset.eyReady) return; f.dataset.eyReady = '1'; new EyDrawerSearch(f);
  });
}
document.addEventListener('DOMContentLoaded', eyHeaderInit);
document.addEventListener('shopify:section:load', eyHeaderInit);
if (document.readyState !== 'loading') eyHeaderInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ey-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
class EyHeroSlideshow {
  constructor(root) {
    this.root = root;
    this.slides = Array.from(root.querySelectorAll('[data-ey-hero-slide]'));
    this.dots = Array.from(root.querySelectorAll('[data-ey-hero-dot]'));
    this.status = root.querySelector('[data-ey-hero-status]');
    this.index = 0;
    this.timer = null;
    this.speed = parseInt(root.dataset.speed, 10) || 6000;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.wantsAutoplay = root.dataset.autoplay === 'true';
    this.paused = false;

    if (this.slides.length < 2) return;

    this.bind();

    // Hold autoplay until the page has settled. A slide changing while the
    // browser is still choosing its LCP candidate can push the reported LCP
    // out to the moment of the swap.
    if (document.readyState === 'complete') {
      setTimeout(() => this.start(), 900);
    } else {
      window.addEventListener('load', () => setTimeout(() => this.start(), 900), { once: true });
    }
  }

  bind() {
    const prev = this.root.querySelector('[data-ey-hero-prev]');
    const next = this.root.querySelector('[data-ey-hero-next]');

    if (prev) prev.addEventListener('click', () => this.step(-1, true));
    if (next) next.addEventListener('click', () => this.step(1, true));

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i, true));
      dot.addEventListener('keydown', (event) => this.onDotKeydown(event, i));
    });

    this.root.addEventListener('mouseenter', () => this.pause());
    this.root.addEventListener('mouseleave', () => this.resume());
    this.root.addEventListener('focusin', () => this.pause());
    this.root.addEventListener('focusout', (event) => {
      if (!this.root.contains(event.relatedTarget)) this.resume();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { this.stop(); } else { this.start(); }
    });

    if (typeof this.reduceMotion.addEventListener === 'function') {
      this.reduceMotion.addEventListener('change', () => this.start());
    }

    this.bindSwipe();
    this.warmSlides();
  }

  // Slides stay loading="lazy" / fetchpriority="low" in the markup so they never
  // compete with the LCP image. Once the page has loaded we pull them into cache
  // in the background, so switching slides never shows an empty frame.
  warmSlides() {
    const warm = () => {
      this.slides.forEach((slide, i) => {
        if (i === 0) return;
        const img = slide.querySelector('img');
        const src = img && (img.currentSrc || img.src);
        if (!src) return;
        const preloader = new Image();
        if (img.srcset) preloader.srcset = img.srcset;
        if (img.sizes) preloader.sizes = img.sizes;
        preloader.src = src;
      });
    };

    const schedule = () => {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warm, { timeout: 2500 });
      } else {
        setTimeout(warm, 900);
      }
    };

    if (document.readyState === 'complete') schedule();
    else window.addEventListener('load', schedule, { once: true });
  }

  bindSwipe() {
    const viewport = this.root.querySelector('[data-ey-hero-viewport]');
    if (!viewport) return;

    let startX = null;
    let startY = null;

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') return;
      startX = event.clientX;
      startY = event.clientY;
    }, { passive: true });

    viewport.addEventListener('pointerup', (event) => {
      if (startX === null) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      startX = null;
      startY = null;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      this.step(dx < 0 ? 1 : -1, true);
    }, { passive: true });
  }

  onDotKeydown(event, i) {
    const last = this.dots.length - 1;
    let target = null;

    if (event.key === 'ArrowRight') target = i === last ? 0 : i + 1;
    else if (event.key === 'ArrowLeft') target = i === 0 ? last : i - 1;
    else if (event.key === 'Home') target = 0;
    else if (event.key === 'End') target = last;

    if (target === null) return;
    event.preventDefault();
    this.goTo(target, true);
    this.dots[target].focus();
  }

  step(direction, byUser) {
    const last = this.slides.length - 1;
    let target = this.index + direction;
    if (target > last) target = 0;
    if (target < 0) target = last;
    this.goTo(target, byUser);
  }

  goTo(target, byUser) {
    if (target === this.index) return;

    this.slides[this.index].classList.remove('is-active');
    this.slides[target].classList.add('is-active');

    this.dots.forEach((dot, i) => {
      const active = i === target;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
      dot.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.index = target;

    if (byUser && this.status) {
      this.status.textContent = 'Slide ' + (target + 1) + ' of ' + this.slides.length;
      this.restart();
    }
  }

  get canAutoplay() {
    return this.wantsAutoplay && !this.reduceMotion.matches && !document.hidden && !window.Shopify?.designMode;
  }

  start() {
    this.stop();
    if (!this.canAutoplay || this.paused) return;
    this.timer = setInterval(() => this.step(1, false), this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  }

  restart() { this.start(); }
  pause() { this.paused = true; this.stop(); }
  resume() { this.paused = false; this.start(); }
}

function eyHeroInit() {
  document.querySelectorAll('[data-ey-hero]').forEach((root) => {
    if (root.dataset.eyHeroReady === 'true') return;
    root.dataset.eyHeroReady = 'true';
    new EyHeroSlideshow(root);
  });
}

document.addEventListener('DOMContentLoaded', eyHeroInit);
document.addEventListener('shopify:section:load', eyHeroInit);
if (document.readyState !== 'loading') eyHeroInit();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
